import {
  Maybe as HygraphMaybe,
  Separator as HygraphSeparator,
} from '@/lib/types';

import { SeparatorProps } from '@/components/separator';

import spacingTransformer from '@/hygraph/transformers/spacing.transformer';

export default function separatorTransformer(
  props: HygraphMaybe<HygraphSeparator> | undefined
) {
  if (!props) {
    return undefined;
  }

  const { separatorType, spacing } = props as HygraphSeparator;

  return {
    separatorType: separatorType || undefined,
    spacing: spacingTransformer(spacing),
  } as SeparatorProps;
}
